import { useQuery } from '@tanstack/react-query';
import {
  getMyWorkflows,
  getAssignedWorkflows,
  getWorkflowById,
  getPendingPayments,
  getImprestEligibility,
  getRequisitionHistory,
} from '../api/workflows';

export const useMyWorkflows = (filters, options = {}) => {
  const query = useQuery({
    queryKey: ['workflows', 'my-workflows', filters],
    queryFn: () => getMyWorkflows(filters),
    keepPreviousData: true,
    enabled: options.enabled !== false,
  });

  return {
    ...query,
    workflows: query.data?.data?.workflows ?? [],
    pagination: query.data?.data?.pagination ?? {
      currentPage: 1,
      pageSize: filters?.limit ?? 10,
      totalItems: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };
};

export const useRequisitionHistory = (filters, options = {}) => {
  const query = useQuery({
    queryKey: ['workflows', 'history', filters],
    queryFn: () => getRequisitionHistory(filters),
    keepPreviousData: true,
    enabled: options.enabled !== false,
  });

  return {
    ...query,
    workflows: query.data?.data?.workflows ?? [],
    pagination: query.data?.data?.pagination ?? {
      currentPage: 1,
      pageSize: filters?.limit ?? 10,
      totalItems: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };
};

export const useAssignedWorkflows = (filters, options = {}) => {
  const query = useQuery({
    queryKey: ['workflows', 'assigned', filters],
    queryFn: () => getAssignedWorkflows(filters),
    keepPreviousData: true,
    enabled: options.enabled !== false,
  });

  return {
    ...query,
    workflows: query.data?.data?.workflows ?? [],
    pagination: query.data?.data?.pagination ?? {
      currentPage: 1,
      pageSize: filters?.limit ?? 10,
      totalItems: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };
};

export const useWorkflow = (id, options = {}) => {
  const query = useQuery({
    queryKey: ['workflows', id],
    queryFn: () => getWorkflowById(id),
    enabled: !!id && options.enabled !== false,
  });

  return {
    ...query,
    workflow: query.data?.data?.workflow ?? null,
  };
};

export const usePendingPayments = (filters, options = {}) => {
  const query = useQuery({
    queryKey: ['workflows', 'payments', filters],
    queryFn: () => getPendingPayments(filters),
    keepPreviousData: true,
    enabled: options.enabled !== false,
  });

  return {
    ...query,
    workflows: query.data?.data?.workflows ?? [],
    pagination: query.data?.data?.pagination ?? {
      currentPage: 1,
      pageSize: filters?.limit ?? 10,
      totalItems: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };
};

export const useImprestEligibility = (options = {}) => {
  const query = useQuery({
    queryKey: ['workflows', 'imprest', 'eligibility'],
    queryFn: getImprestEligibility,
    enabled: options.enabled !== false,
  });

  return {
    ...query,
    eligibility:
      query.data?.data ?? {
        canCreate: true,
        overdueWorkflows: [],
        reason: null,
      },
  };
};

export default useMyWorkflows;


